export default {
    methods: {
        save() {
            this.$store.dispatch('usersModify', this.user).then(() => {
                this.user = this.me
            })
        },
    },
}
